var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarBasicinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7V5C7 3.89543 7.89543 3 9 3H20C21.1046 3 22 3.89543 22 5V14C22 15.1046 21.1046 16 20 16H15M11 7.5H18M14 11.5H18M5.58579 16.5858C6.36683 17.3668 7.63317 17.3668 8.41421 16.5858C8.78929 16.2107 9.29799 16 9.82843 16H10C11.1046 16 12 16.8954 12 18V19C12 20.1046 11.1046 21 10 21H4C2.89543 21 2 20.1046 2 19V18C2 16.8954 2.89543 16 4 16H4.17157C4.70201 16 5.21071 16.2107 5.58579 16.5858ZM9 12C9 13.1046 8.10457 14 7 14C5.89543 14 5 13.1046 5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12Z",
    stroke: "current",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBasicinfo);
export default __webpack_public_path__ + "static/media/sidebar-basicinfo.4542983b7481533e3f0e50ed95b0ce6b.svg";
export { ForwardRef as ReactComponent };